import { render, staticRenderFns } from "./BusinessTaxReturn.vue?vue&type=template&id=10eb649a&scoped=true&"
import script from "./BusinessTaxReturn.vue?vue&type=script&lang=ts&"
export * from "./BusinessTaxReturn.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTaxReturn.vue?vue&type=style&index=0&id=10eb649a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb649a",
  null
  
)

export default component.exports